import {
  TransactionCancellationReasonDto,
  TransactionCancellationReasonModel,
} from '../types/transaction-cancellation'

export const transformTransactionCancellationReasonDto = (
  reason: TransactionCancellationReasonDto,
): TransactionCancellationReasonModel => ({
  id: reason.id,
  hasInput: reason.has_input,
  reason: reason.reason,
  showNearestDropOffPoint: reason.show_nearest_drop_off_point,
  bannerText: reason.banner_text,
})

export const transformTransactionCancellationReasonsDto = (
  reasons: Array<TransactionCancellationReasonDto>,
): Array<TransactionCancellationReasonModel> =>
  reasons.map(transformTransactionCancellationReasonDto)
